import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import InputComponent from "../../../components/InputComponent";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import ButtonComponent from "../../ButtonComponent";
import { AssistanceUpdateDTO } from "../../../models/Assistance/AssistanceUpdateDTO";
import { AssistanceService } from "../../../services/AssistanceService";
import Toast from "../../../helpers/Toast";
import { useIntl } from "react-intl";
import React from "react";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import { RenderCountersInputs } from "../RenderCountersInputs";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";

type AssistanceDetailsComponentType = {
    assistance: AssistanceDTO;
    setAssistance: React.Dispatch<React.SetStateAction<AssistanceDTO>>;
    isLoadingAssistance: boolean;
    getAssistance: () => Promise<void>;
};

export type SelectItemsProps = {
    label: string;
    value: string;
};

export function AssistanceDetailsB({ assistance, setAssistance, isLoadingAssistance, getAssistance }: AssistanceDetailsComponentType) {

    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const assistanceService = new AssistanceService();

    // tipo assistencia
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    //módulos ativos
    const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
    const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);
    const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);

    useEffect(() => {
        if (availableModules.includes("IsActiveCountersModule")) {
            setIsActiveCountersModule(true);
        }
        if (availableModules.includes("IsActiveErpSupportModule")) {
            setIsActiveErpSupportModule(true);
        }
    }, [availableModules]);

    //passar dados para inputs dinamicos
    const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>(assistance.timeHistory || {});
    useEffect(() => {
        if (assistance.timeHistory) {
            setTimeHistory(assistance.timeHistory);
        }
    }, [assistance.timeHistory]);

    // ao atualizar valor dos inputs, levar valor para processo de editar assistência
    useEffect(() => {
        setAssistance((prev: AssistanceDTO) => ({ ...prev, timeHistory }));
    }, [timeHistory]);


    useEffect(() => {
        if (assistance.id != 0) {
            getAssistance();
        }
    }, []);

    const EditAssistance = async () => {
        var data: AssistanceUpdateDTO = {
            id: assistance.id,
            date: assistance.date,
            counter1: assistance.timeHistory.counter1 || 0,
            counter2: assistance.timeHistory.counter2 || 0,
            counter3: assistance.timeHistory.counter3 || 0,
            counter4: assistance.timeHistory.counter4 || 0,
            counter5: assistance.timeHistory.counter5 || 0,
            counter6: assistance.timeHistory.counter6 || 0,
            projectErpId: assistance.project?.erpId ?? null,
            clientErpId: assistance.client?.erpId ?? null,
            assistanceType: selectedAssistanceType || assistance.assistanceType,
        };

        setIsLoading(true);
        var response = await assistanceService.Edit(data);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }
        Toast.Show("success", "Assistência editada com sucesso");
        setIsLoading(false);
    };

    useEffect(() => {
        setIsComplete(!assistance.userCanEdit);

    }, [assistance]);

    const intl = useIntl();

    return (
        <>
            {isComplete ? (
                ""
            ) : (
                <Row style={{ margin: "0px", padding: "0px", justifyContent: "start" }}>
                    <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                        <ButtonComponent
                            style={{ width: "100%", marginTop: "10px" }}
                            text={intl.formatMessage({ id: "AssistanceDetailsB.Save" })}
                            onClick={() => EditAssistance()}
                            disabled={isLoading}
                        />
                    </Col>
                </Row>
            )}
            <Row style={{ margin: "1rem 0px 0px 0px", padding: "0px" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.carPlate}
                    label={"Matricula"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={8}
                    lg={8}
                    md={8}
                    sm={8}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment == null ? assistance?.client?.name : assistance?.equipment?.client?.name}
                    label={assistance?.equipment == null ? "Cliente" : "Cliente Equipamento"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.serialNumber}
                    label={"Nº Série"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.brand}
                    label={"Marca"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.model}
                    label={"Modelo"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistance?.date}
                    label={"Dia"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: Date) => {
                        setAssistance({ ...assistance!, date: t });
                    }}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={assistance?.date != null ? Utilities.GetTimeFromDateTime(new Date(assistance?.date)) : ""}
                    label={"Hora"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({
                            ...assistance!,
                            date: new Date(`${Utilities.formatDate(new Date(assistance?.date))}T${t}`),
                        });
                    }}
                />
            </Row>

            {/* Estado 2 - Contadores */}
            {isActiveCountersModule && !isActiveErpSupportModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEditB.CountersTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory, isComplete)}
                    </Row>
                </>
            )}

            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.description}
                    label={"Descrição do Serviço"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, description: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.workDone}
                    label={"Trabalho Efetuado"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, workDone: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance?.notes}
                    label={"Observações"}
                    readOnly={isComplete}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance!, notes: t });
                    }}
                />
            </Row>
        </>
    );
}
